import { SERVICELEVELSLIST, STORAGECONDITIONS, ORDER_SUPPLIES, QC_TYPE_OPTIONS } from 'constants/apis';
import Fetch from 'helpers/fetch';
import log from 'loglevel';

const fetchStorageConditions = function FetchStorageConditions() {
  return new Promise((resolve, reject) => {
    Fetch.Get(STORAGECONDITIONS)
      .then(resp => resp.json())
      .then((data) => {
        this.setState({
          ShelfLifeStorageConditions: (data.DataList || []).map(item => ({
            label: item.ShelfLifeName,
            value: item.ShelfLife,
          })),
        });

        resolve();
      })
      .catch((err) => { log.error(err); reject(err); });
  });
};

const fetchServiceLevel = function FetchServiceLevel() {
  return new Promise((resolve, reject) => {
    Fetch.Get(SERVICELEVELSLIST)
      .then(resp => resp.json())
      .then((data) => {
        this.setState({
          ServiceLevels: (data.DataList || [])
            .filter(serviceLevel => serviceLevel.DisplayValue !== '')
            .map(item => ({
              label: item.DisplayValue,
              value: item.Index,
            })),
        });

        resolve();
      })
      .catch((err) => { log.error(err); reject(err); });
  });
};

const fetchOrderSupplies = function FetchOrderSupplies() {
  return new Promise((resolve, reject) => {
    Fetch.Get(ORDER_SUPPLIES)
      .then(resp => resp.json())
      .then((data) => {
        this.setState({
          orderSupplies: (data.DataList || []).map(orderSupply => ({
            ...orderSupply,
            Quantity: '',
          })),
        });
        resolve();
      })
      .catch((err) => { log.error(err); reject(err); });
  });
};

const fetchQCTypeOptions = function FetchQCTypeOptions() {
  return new Promise((resolve, reject) => {
    Fetch.Get(QC_TYPE_OPTIONS)
      .then(resp => resp.json())
      .then((data) => {
        this.setState({
          QcTypeOptions: (data.DataList || []).map(qcType => ({
            label: qcType.Label,
            value: qcType.QCSampleID,
          })),
        });
        resolve();
      })
      .catch((err) => { log.error(err); reject(err); });
  });
};

export {
  fetchStorageConditions,
  fetchServiceLevel,
  fetchOrderSupplies,
  fetchQCTypeOptions,
};



// WEBPACK FOOTER //
// ./src/helpers/initialize.js